import type { ReactNode } from 'react'

/** A single mobile-width surface panel: rounded, hairline border, soft shadow.
 *  The one repeated container shape for slot/assignment rows and the login
 *  card — deliberately plain (no desktop grid/table primitives). `as` lets a
 *  caller keep a semantic element (e.g. `section` for a per-team panel) while
 *  reusing the surface style. */
export function Card({
  children,
  className,
  as: Tag = 'div',
}: {
  children: ReactNode
  className?: string
  as?: 'div' | 'section'
}) {
  return (
    <Tag
      className={[
        'rounded-lg bg-surface border border-line shadow-sm p-4 flex flex-col gap-3',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </Tag>
  )
}
